<template>
   <div></div>
</template>

<script>
export default {
   components: {},
   data() {
      return {};
   },
   created() {},
   mounted() {},
   computed: {},
   methods: {},
   watch: {},
};
</script>

<style lang="sass" scoped></style>
